import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var Bookmark2Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#bookmark-1__a)",
                            children: _jsx("path", {
                                d: "M22.595 1.415c-.49-.49-1.14-.76-1.83-.76H3.245c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v17.51c0 .68.28 1.35.76 1.83.49.49 1.14.76 1.83.76h17.51c.69 0 1.34-.27 1.83-.76s.76-1.15.76-1.83V3.245c0-.69-.27-1.34-.76-1.83h.01zm-19.77 1.41a.59.59 0 01.42-.17h17.51c.16 0 .31.06.42.17.11.11.17.26.17.42v2.17H2.655v-2.17c0-.16.06-.31.17-.42zm9.38 4.59h4.37v7.74l-1.48-1.48a.996.996 0 00-1.41 0l-1.48 1.48v-7.74zm8.97 13.76a.59.59 0 01-.42.17H3.245a.59.59 0 01-.42-.17.59.59 0 01-.17-.42V7.425h7.55v10.15c0 .4.24.77.62.92.37.16.8.07 1.09-.22l2.48-2.48 2.48 2.48c.19.19.45.29.71.29.13 0 .26-.02.38-.08.37-.15.62-.52.62-.92V7.425h2.78v13.34c0 .16-.06.31-.17.42l-.02-.01z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "bookmark-1__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
Bookmark2Icon.isCarinaIcon = true;
export default Bookmark2Icon;
